import type { FunctionComponent } from 'react';

import { L10nText } from '../../../services/uiTranslations/reactBindings/L10nText';
import { useHeaderSlice } from '../../../store/slices/header/selectors';

import { NavPages } from './NavPagesConnected';

export const NavPagesTitleConnected: FunctionComponent = () => {
  const routeLevelLength = useHeaderSlice.getNavRouteLevel();
  const currentNavRoute = useHeaderSlice.getNavRouteByLevel(routeLevelLength);
  const routeByLevel = useHeaderSlice.getNavRouteByLevel(2);

  switch (routeByLevel) {
    case NavPages.SUPPORT:
      return <L10nText tk="LIVE_SUPPORT" />;
    case NavPages.CHAT:
      return <L10nText tk="CHAT" />;
    case NavPages.SETTINGS:
      return <L10nText tk={currentNavRoute ?? 'SETTINGS'} />;
    case NavPages.HISTORY:
      return <L10nText tk="HISTORY" />;
    case NavPages.BET_LIMITS:
      return <L10nText tk="MENU_PAYOUTS_LIMITS" />;
    case NavPages.HELP:
      return <L10nText tk="HELP" />;
    case NavPages.QUICK_GUIDE:
      return <L10nText tk="QG_QUICK_GUIDE" />;
    default:
      return <L10nText tk="MENU" />;
  }
};
